import React from 'react';
import PropTypes from 'prop-types';
import {i18n} from '../../Utility/Format';
import bothCellBackground from '../../Resources/Images/date_cell_both.svg';
import classnames from 'classnames';

/**
 * Displays an icon explaining how currencies are mapped to colors. It's used for the value date calendar.
 * You can have a fully colored square for base OR counter. Or a diagonally separated square for BOTH base and counter.
 */
const CurrencyHolidayIcon = (props) => {
    const classNames = classnames('currency-holiday-icon', {
        'currency-holiday-icon--base': props.baseCcy,
        'currency-holiday-icon--counter': props.counterCcy
    });

    let bothActiveStyle = {};
    let currencyString = props.baseCcy || props.counterCcy;

    if (props.baseCcy && props.counterCcy) {
        bothActiveStyle = {backgroundImage: `url(${bothCellBackground})`};
        currencyString = props.baseCcy + ' + ' + props.counterCcy
    }

    return (
        <div className={classNames}>
            <div className="currency-holiday-icon__square" style={bothActiveStyle}></div>
            <span className="currency-holiday-icon__label">
                {i18n('dbm.currency.holiday')} {currencyString}
            </span>
        </div>
    );
};

CurrencyHolidayIcon.propTypes = {
    baseCcy: PropTypes.string,
    counterCcy: PropTypes.string
};

export default CurrencyHolidayIcon;